






















































import Vue from 'vue';
import key from '@/libs/filters/key';
import layout from '@/libs/layout/school/project';
import { Component, Prop } from 'vue-property-decorator';
import {
  TProjectPage,
  TProjectListSearch,
  TProjectList
} from '@/types/views/school';
import { TLayout } from '@/types/utils';
@Component({})
export default class Project extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 0,
        currentPage: 1,
        pageSize: 20,
        list: []
      };
    }
  })
  page!: TProjectPage;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  private layout: TLayout = layout;
  private key: any = key;
  private project: TProjectListSearch = {
    name: '',
    status: ''
  };
  private indexMethod(idx: number) {
    const { currentPage, pageSize } = this.page;
    return ((currentPage as number) - 1) * (pageSize as number) + idx + 1;
  }
  handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  handleSize(size: number) {
    this.handleOptions({ size });
    this.getData();
  }
  search() {
    this.handleOptions({
      status: this.project.status,
      projectName: this.project.name,
      currentPage: 1
    });
    this.getData();
  }
  handleDetail(idx: number, row: TProjectList) {
    window.open(
      `${process.env.VUE_APP_API}.replace('/core','')}/create?projectId=${
        row.id
      }`
    );
  }
}
